import PropTypes from 'prop-types';
import styled from 'styled-components';
import DeliveryTips from './DeliveryTips';
import SectionSubHeader from '../SectionSubHeader/SectionSubHeader';

const DeliveryTipsSection = ({ isUpdate, ...props }) => (
  <StyledDeliveryTipsSection>
    <SectionSubHeader className="delivery-tip-title">{`Would you like to ${
      isUpdate ? 'update your' : 'add a'
    } delivery tip?`}</SectionSubHeader>
    <div className="delivery-tip-title-sub">
      Please note that delivery tip options expire 12 hours after order placement.
    </div>
    <DeliveryTips {...props} />
  </StyledDeliveryTipsSection>
);

const StyledDeliveryTipsSection = styled('div')`
  & .delivery-tip-title-sub {
    color: ${(props) => props.theme.text};
    font-size: 14px;
    font-weight: 400;
    margin: 5px 0 5px;
    padding: 0 0 5px;
  }
`;

DeliveryTipsSection.propTypes = {
  subTotal: PropTypes.number,
  selectedCustomTipValue: PropTypes.number,
  addDeliveryTip: PropTypes.func,
  isUpdate: PropTypes.bool,
};

DeliveryTipsSection.defaultProps = {
  subTotal: 0,
  selectedCustomTipValue: 0,
  addDeliveryTip: () => {},
  isUpdate: false,
};

export default DeliveryTipsSection;
